import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { MealAction } from '../../../../store/meal-slice';
import { mealTypeEnum } from '../../../../utils/constants';
const SummarySearchAndFilterComponent = () => {
  const { mealType, showOnly, searchValue } = useSelector(
    (state) => state.meals
  );
  const { language } = useSelector((state) => state.globalUi);
  const dispatch = useDispatch();
  const handleSearch = (e) => {
    dispatch(
      MealAction.searchMealList({ searchName: e.target.value, language })
    );
  };
  return (
    <Stack
      sx={{
        rowGap: 3,
      }}
    >
      <Stack
        sx={{
          p: '0 2.4rem',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Typography component='span' variant='s16_w600'>
          Choose meal type:
        </Typography>
        &nbsp; &nbsp;&nbsp; &nbsp;
        <FormControl>
          <RadioGroup
            aria-labelledby='demo-controlled-radio-buttons-group'
            name='controlled-radio-buttons-group'
            value={mealType}
            onChange={(e) => {
              dispatch(
                MealAction.updateMealType({
                  mealType: e.target.value,
                  language,
                })
              );
            }}
            row
          >
            <FormControlLabel
              value={mealTypeEnum.all}
              control={<Radio />}
              label='All'
            />
            <FormControlLabel
              value={mealTypeEnum.meal}
              control={<Radio />}
              label='Regular Meal'
            />
            <FormControlLabel
              value={mealTypeEnum.catering}
              control={<Radio />}
              label='Catering Food'
            />
            <FormControlLabel
              value={mealTypeEnum.add_ons}
              control={<Radio />}
              label='Add-ons'
            />
          </RadioGroup>
        </FormControl>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          p: '0 2.4rem',
          alignItems: 'center',
          columnGap: 4,
          backgroundColor: '#FBFBFB',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            columnGap: 1,
            alignItems: 'center',
          }}
        >
          <Typography component='span' variant='s16_w500'>
            Quick search:
          </Typography>
          <FormControl
            sx={{
              minWidth: '40rem',
            }}
          >
            <TextField
              placeholder='Enter a keyword to search boxes'
              value={searchValue}
              onChange={handleSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            columnGap: 1,
            alignItems: 'center',
          }}
        >
          <Typography component='span' variant='s16_w500'>
            Show only:
          </Typography>
          <FormGroup
            sx={{ display: 'flex', flexDirection: 'row', columnGap: 3 }}
          >
            {['Vegetarian', 'Halal'].map((item) => (
              <FormControlLabel
                key={item}
                checked={showOnly?.includes(item) ?? false}
                onChange={() =>
                  dispatch(
                    MealAction.updateShowOnlyFilter({
                      filterType: item,
                      language,
                    })
                  )
                }
                control={<Checkbox />}
                label={item}
              />
            ))}
          </FormGroup>
        </Box>
      </Box>
    </Stack>
  );
};

export default SummarySearchAndFilterComponent;
